import { getSection } from "./sections";

export function updateSpaceScene () {
  const spaceSceneData = getSection('contact');
  const onScreenPortion = spaceSceneData.onScreenPortion;
  const offScreen = spaceSceneData.onScreenPortion <= 0;
  const renderCacheKey = window.jmAppState.renderKey;

  // Kill if janky
  const kill = window.jmAppState.killParralax;

  // Don't bother if we already rendered at this scroll position or if this element is off screen
  if (!kill && (renderCacheKey === window.jmAppState.spaceScene.lastRenderedCacheKey || offScreen)) {
    return;
  } else {
    window.jmAppState.spaceScene.lastRenderedCacheKey = renderCacheKey;
  }

  // Work out how much to shift scene. Don't shift at all if killing
  const shiftFactor = kill ? 0 : 1 - onScreenPortion;

  // Shift the planes and adjust colours. Don't make things fully opaque or transparent for iOS Safari performance
  const safeOpacity = (opacity) => Math.max(Math.min(.999, opacity), .001);
  for (let plane of Object.values(window.jmAppState.spaceScene.planes)) {
    const shift = shiftFactor * plane.shift;
    const scale = plane.zoom ? shiftFactor * (plane.zoom - 1) + 1 : 1;
    const transform = `translate(0, ${shift * 100}%) scale(${scale})`;
    plane.scene.style.transform = transform;
    if (plane.fade) {
      plane.scene.style.opacity = safeOpacity(1 - shiftFactor);
    }
  }
};

export function initSpaceManOrbit() {
  // add 'orbit' class on click and remove after animation has had time to complete
  const sectionData = getSection('contact');

  const astronaut = document.querySelector('#contact .astronautOrbitX');
  astronaut.addEventListener('click', (event) => {

    if (!astronaut.parentNode.classList.contains('orbit')) {
      astronaut.parentNode.classList.add('orbit');
      ga('send', 'event', 'surprises', 'click', 'spaceman orbit');
      sectionData.spaceManOrbitTimeout = window.setTimeout(() => {
        astronaut.parentNode.classList.remove('orbit');
      }, 10500);
    }
  })
}